import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import { HomeOutlined, PlaylistAddCheck } from "@mui/icons-material";
import { Box, Button, Checkbox, CircularProgress, FormControlLabel, Grid } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi } from 'api/general';
import { postBulkVoteActionApi } from 'api/meeting';
import DshReviewVoteTitle from "app/components/Box/DshReviewVoteTitle";
import AddUpdateVoteCard from 'app/components/Card/AddUpdateVoteCard';
import VoteStatusCard from 'app/components/Card/VoteStatusCard';
import BulkVoteActionDialog from 'app/components/Dialog/BulkVoteActionDialog';
import LoadingPopUp from 'app/components/LoadingPopup';
import VisiblePageRow from 'app/components/VisiblePageRow';
import { sortByProperty } from 'app/utils/appHelpers';
import { DECISION, DECISION_FILE, MEETING_USER, VOTE } from 'app/utils/constants/customConstant';
import { redColor } from 'app/themes/main/default';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentMeeting, setCurrentMeetingUsers, showAgendaSnackbar } from "stores/meeting";
import Swal from 'sweetalert2';
import DashboardPageToolBar from './DashboardPageToolBar';

const VotePage = () => {
    const navigate = useNavigate();
    const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
    const { authUser } = useSelector(state => state.auth);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [loading, setLoading] = useState(false);
    const [decisionsOfTheMeeting, setDecisionsOfTheMeeting] = useState([]);
    const [votesOfTheMeeting, setVotesOfTheMeeting] = useState([]);
    const [voteInputStatus, setVoteInputStatus] = useState(false);
    const [filteredDecisions, setFilteredDecisions] = useState(null);
    const [highlightQuery, setHighlightQuery] = useState('');
    const [decisionFiles, setDecisionFiles] = useState([]);
    const userList = useSelector(state => state.user.data || []);

    const [selectedDecisions, setSelectedDecisions] = useState([]);
    const [bulkDialogOpen, setBulkDialogOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const dispatch = useDispatch();

    const isBulkMode = decisionsOfTheMeeting.length > 50;

    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);
            try {
                const [res, res2, res3, resFiles] = await Promise.all([
                    getObjectListByPropertyApi(DECISION, "meetingId", currentMeeting.id),
                    getObjectListByPropertyApi(VOTE, "meetingId", currentMeeting.id),
                    getObjectListByPropertyApi(MEETING_USER, "meetingId", currentMeeting.id),
                    getObjectListByPropertyApi(DECISION_FILE, "meetingId", currentMeeting.id)
                ]);
                const sorted = sortByProperty(res.data, "decisionNo");
                setDecisionsOfTheMeeting(sorted);
                setFilteredDecisions(sorted);
                setVotesOfTheMeeting(res2.data);
                setDecisionFiles(resFiles.data || []);

                let data = res3.data.filter(item => item.type === 1)
                data = sortByProperty(data, "indexNo")
                dispatch(setCurrentMeetingUsers(data));

            } catch (error) {
                console.error("Hata:", error);
            } finally {
                setLoading(false);
            }
        };
        getAPI();
    }, []);

    const addAfterTable = (item) => {
        let tmp = votesOfTheMeeting; tmp.unshift(item); setVotesOfTheMeeting(tmp)
        setVoteInputStatus(true)
    }

    const handleDelete = async (vote) => {

        const result = await deleteObjectApi(VOTE, vote.id);

        if (result.status) {

            const filteredList = votesOfTheMeeting.filter(x =>
                !(x.id === vote.id)
            );
            setVotesOfTheMeeting(filteredList);
            setVoteInputStatus(true)
            return result
        } else {
            return null;
        }
    };

    const updateAfterTable = (item) => {
        let tmp = votesOfTheMeeting;
        const index = votesOfTheMeeting.findIndex(x => x.id === item.id);
        index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(votesOfTheMeeting[votesOfTheMeeting.length - 1].id) + 1 })
        setVotesOfTheMeeting([...tmp]);
        setVoteInputStatus(true)

    }

    const handleHomeClick = () => {
        const unvotedDecisions = decisionsOfTheMeeting.filter(item =>
            !votesOfTheMeeting.some(vote =>
                vote.userId === authUser.id && vote.decisionId === item.id
            )
        );

        unvotedDecisions.length > 0 ?
            Swal.fire({
                html: `
                 <h4>Aşağıdaki karar(lar)a oy vermediniz!</h4>
                <ul style="list-style-type: none; padding: 0; max-height: 300px; overflow-y: auto; font-size: 13px;">
                    ${unvotedDecisions.map(decision => `
                        <li style="margin-bottom: 5px;">
                    Karar Maddesi: <span style="color: ${redColor}">${decision.decisionNo}</span>
                        </li>
                    `).join("")}
                </ul>
                <p>Ana Sayfaya dönmek istediğinizden emin misiniz?</p>
            `,
                customClass: {
                    container: 'swal-container-custom'
                },
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {
                if (result.isConfirmed) {
                    dispatch(setCurrentMeetingUsers([]))
                    dispatch(setCurrentMeeting({}))
                    navigate("/")
                    setSidebarOptions({ open: true })
                }
            })

            :

            Swal.fire({
                position: 'center',
                icon: 'success',
                text: "Tüm kararlara oy verdiniz",
                showConfirmButton: false,
                timer: 2000
            }).then(async () => {
                navigate("/")
                setSidebarOptions({ open: true })
            })
    }

    const handleSelectDecision = (decisionId) => {
        setSelectedDecisions(prev =>
            prev.includes(decisionId)
                ? prev.filter(id => id !== decisionId)
                : [...prev, decisionId]
        );
    };

    const handleSelectAll = () => {
        if (filteredDecisions && selectedDecisions.length === filteredDecisions.length) {
            setSelectedDecisions([]);
        } else {
            setSelectedDecisions(filteredDecisions.map(d => d.id));
        }
    };

    const handleBulkVote = async (type) => {
        setBulkDialogOpen(false);
        await new Promise(resolve => setTimeout(resolve, 150));

        const loadingStartTime = Date.now();
        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            color: '#000',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: { container: 'swal-container-custom' },
            didOpen: () => Swal.showLoading()
        });

        try {
            const allDecisionIds = decisionsOfTheMeeting.map(d => d.id);
            const excludeDecisionIds = allDecisionIds.filter(id => !selectedDecisions.includes(id));

            const result = await postBulkVoteActionApi({
                meetingId: currentMeeting.id,
                userId: authUser.id,
                inst: authUser.inst,
                voteType: type,
                excludeDecisionIds
            });
            if (result.status) {
                setVotesOfTheMeeting(result.data);
                setSelectedDecisions([]);
                setRefreshKey(prev => prev + 1);

                const elapsedTime = Date.now() - loadingStartTime;
                if (elapsedTime < 700) {
                    await new Promise(resolve => setTimeout(resolve, 700 - elapsedTime));
                }

                Swal.close();
                dispatch(showAgendaSnackbar({
                    message: 'İşlem başarıyla tamamlandı.',
                    severity: 'success'
                }));
            } else {
                Swal.close();
                dispatch(showAgendaSnackbar({
                    message: result.errorMessage || 'İşlem sırasında hata oluştu.',
                    severity: 'error'
                }));
            }
        } catch (error) {
            console.error('Hata:', error);
            Swal.close();
            dispatch(showAgendaSnackbar({
                message: 'İşlem sırasında hata oluştu.',
                severity: 'error'
            }));
        }
    };
    const adminUser = userList.find(item => item.id === currentMeeting.adminUserId);

    return (

        <>
            <LoadingPopUp open={loading} />

            {!loading && <Box sx={{  }}>
                <Box
                    sx={{
                        position: "sticky",
                        top: "75px",
                        zIndex: 1100,
                        backgroundColor: "#fff",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        p: 1,
                        borderRadius: "20px",
                        maxHeight: "80px",
                        marginBottom: 1,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                        }}
                    >
                        <DshReviewVoteTitle
                            currentMeeting={currentMeeting}
                            adminUser={adminUser}
                        />

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            <DashboardPageToolBar
                                data2={decisionsOfTheMeeting}
                                setData={setFilteredDecisions}
                                setHighlightQuery={setHighlightQuery}
                            />
                            <Button onClick={() => handleHomeClick()} startIcon={<HomeOutlined />} sx={{ whiteSpace: 'nowrap' }}>
                                Ana Sayfa
                            </Button>
                        </Box>
                    </Box>
                </Box>

                {isBulkMode && filteredDecisions !== null && filteredDecisions.length > 0 && (
                    <Box sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={selectedDecisions.length === filteredDecisions.length}
                                    indeterminate={selectedDecisions.length > 0 && selectedDecisions.length < filteredDecisions.length}
                                    onChange={handleSelectAll}
                                    sx={{ color: 'primary.main', '&.Mui-checked': { color: 'primary.main' } }}
                                />
                            }
                            label="Tümünü Seç"
                            sx={{ ml: 0 }}
                        />
                        {selectedDecisions.length > 0 && (
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<PlaylistAddCheck />}
                                onClick={() => setBulkDialogOpen(true)}
                                sx={{ whiteSpace: 'nowrap' }}
                            >
                                Toplu İşlem ({selectedDecisions.length})
                            </Button>
                        )}
                    </Box>
                )}

                {filteredDecisions !== null &&
                    filteredDecisions.map((decision, index) => {
                        const voteOfTheUser = votesOfTheMeeting.find(
                            (item) => item.decisionId === decision.id && item.userId === authUser.id
                        );

                        let filteredList = votesOfTheMeeting.filter(
                            (item) => item.decisionId === decision.id
                        );

                        return (
                            <VisiblePageRow key={`${decision.id}-${refreshKey}`}>
                            <Grid container spacing={1} sx={{ marginBottom: 1 }}>
                                {isBulkMode && (
                                    <Grid item xs={12} sx={{ pb: 0, pt: 0 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={selectedDecisions.includes(decision.id)}
                                                    onChange={() => handleSelectDecision(decision.id)}
                                                    sx={{ color: 'primary.main', '&.Mui-checked': { color: 'primary.main' } }}
                                                />
                                            }
                                            label={`Karar ${decision.decisionNo}`}
                                            sx={{ ml: 0 }}
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={12} md={6} lg={8}>
                                    <AddUpdateVoteCard
                                        voteOfTheUser={voteOfTheUser}
                                        setVoteInputStatus={setVoteInputStatus}
                                        handleDelete={handleDelete}
                                        decision={decision}
                                        index={decision.id}
                                        addAfterTable={addAfterTable}
                                        updateAfterTable={updateAfterTable}
                                        highlightQuery={highlightQuery}
                                        decisionFiles={decisionFiles}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6} lg={4}>
                                    <VoteStatusCard
                                        setVoteInputStatus={setVoteInputStatus}
                                        votesOfTheMeeting={filteredList}
                                    />
                                </Grid>
                            </Grid>
                            </VisiblePageRow>
                        );
                    })
                }
            </Box>
            }

            <BulkVoteActionDialog
                open={bulkDialogOpen}
                onClose={() => setBulkDialogOpen(false)}
                onAction={handleBulkVote}
                selectedCount={selectedDecisions.length}
            />
        </>
    );
}
export default VotePage;

